skrilla.directive('downloadCsvButton',function() {
    return {
        templateUrl: 'views/exportToCsvModal/downloadCsvButton.html',
        scope: {
            data: "=",
            headers: "=",
            filename: "=",
            index: "="
        },
        controller: function($scope, modalService, valuesToWordsService, $filter){
            $scope.getWord  = valuesToWordsService.getWord;
            if($scope.filename === undefined) {
                $scope.filename = "";
            }
            if($scope.index === undefined){
                $scope.index = 0;
            }

            if($scope.headers === undefined) {
                $scope.headers = [];
            }

            if($scope.data.isSkrillaTable){
                $scope.data.exportAsTable = $scope.data.isSkrillaTable
            }

            if($scope.data.isSkrillaTable === true){
                $scope.data.columns.forEach(function(column){
                    $scope.headers.push({key: column.field, title: column.title, selected: true, filter: column.filter});
                })
            }
            else {
                for (var key in $scope.data[0]) {
                    if (!key.includes("hashKey")) {
                        $scope.headers.push({key: key, title: valuesToWordsService.getWord(key), selected: true});
                    }
                }
            }


            $scope.getHeaders = function(){
                var headers = [];
                $scope.headers.forEach(function(header){
                    if(header.selected === true){
                        headers.push(header.title);
                    }
                });
                return headers;
            }

            $scope.getFilename = function(){
                return $scope.filename.replace(".csv");
            }

            function sortSkrillaTable(data){
                if(data.rows.orderBy !== undefined){
                    let desc = data.rows.orderBy.includes("-");
                    let orderBy = data.rows.orderBy.replace("-", "");
                    return data.data.sort(function(a,b){
                        return desc ? ("" + b[orderBy]).localeCompare("" + a[orderBy]) : ("" + a[orderBy]).localeCompare("" + b[orderBy]) ;
                    });
                }
                else{
                    return data.data;
                }
            }


            $scope.getLedger = function(){
                if($scope.data.isSkrillaTable){
                    $scope.data.exportAsTable = $scope.data.isSkrillaTable
                }
                const headers = $scope.headers.filter(header => header.selected === true);

                if($scope.data.isSkrillaTable){
                    return sortSkrillaTable($scope.data).map((val) =>
                        headers.reduce(function (a, header) {
                            let result = val[header.key]
                            if($scope.data.exportAsTable === true){
                                if (header.filter) {
                                    if (header.filter.name) {
                                        result = $filter(header.filter.name)(result, header.filter.args)
                                    } else if (header.filter.func) {
                                        result = header.filter.func(result)
                                    }
                                }
                            }
                            a[header.key] = result?.toString().replace(',', '\,')
                            return a
                        }, {})
                    );
                }
                else {
                    return $scope.data.map((val) =>
                        headers.reduce((a, header) =>  ({...a,
                            [header.key] : val[header.key]?.toString().replace(',', '\,')
                        }), {})
                    )
                }
            }

        }
    };
});
